import { render } from "./DependentStep1.vue?vue&type=template&id=cea5ed24&ts=true"
import script from "./DependentStep1.vue?vue&type=script&lang=ts"
export * from "./DependentStep1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__